<template>
  <div>
    <h3 class="mb-5">QuikTips Overview</h3>
    <div class="h4 mb-5">編輯Overview Page上標題及背景圖</div>

    <!-- page title -->
    <div class="form-item d-flex pt-5">
      <label class="w-174px mr-6px"
        ><h4>Overview Page Title</h4></label
      >
      <div class="flex-grow-1 my-n2">
        <v-text-field
          v-model="bu.quiktips.title"
          outlined
          dense
        ></v-text-field>
      </div>
    </div>
    <!-- img uploader -->
    <div class="form-item d-flex px-5 py-5">
      <div class="w-180px">
        <h4 class="mb-10px">Overview Banner</h4>
        <div class="h5 ink-02-medium--text">
          建議尺寸：999px * 999px <br />
          檔案大小限制：&lt; 1 MB
        </div>
      </div>
      <div class="d-flex justify-end flex-grow-1">
        <ImgUploader
          :imageUrl.sync="bu.quiktips.banner"
          dir="quiktips"></ImgUploader>
      </div>
    </div>

    <h3 class="mb-5 mt-5">QuikTips Detail</h3>
    <div class="h4 mb-5">
      編輯QuikTips於BU Page、Overview Page的封面圖文及QuikTips Detail Page內頁
    </div>
    <!-- Items -->
    <div>
      <div
        class="form-item d-flex py-3 align-center"
        v-for="(item, i) in bu.quiktips.details"
        :key="i"
      >
        <div
          class="w-40px h-40px bg-cover bg-center bg-c"
          :style="{
            'background-image': `url(${item.cover_photo})`,
          }"
        ></div>
        <div class="h4 ml-5">{{ item.title }}</div>
        <div class="ml-auto">
          <button
            class="btn square ml-10px "
            @click="item.is_top = !item.is_top"
          >
            <v-icon v-if="item.is_top" class="warning-500--text">star</v-icon>
            <v-icon v-else>star_border</v-icon>
          </button>
          <button class="btn square ml-10px" @click="editItem(item)">
            <v-icon>edit</v-icon>
          </button>
          <button class="btn square ml-10px" @click="deleteItem(i)">
            <v-icon>delete</v-icon>
          </button>
          <button class="btn square ml-10px" @click="downItem(item, i)">
            <v-icon>arrow_downward</v-icon>
          </button>
          <button class="btn square ml-10px" @click="upItem(item, i)">
            <v-icon>arrow_upward</v-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- add item -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem()">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加QuickTip</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    bu: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImgUploader,
  },
  methods: {
    ...mapActions('bupage', ['initQuicktipsDetail']),
    addItem() {
      const detail = {
        title: '',
        cover_photo: '',
        detail_page_title: '',
        detail_page_banner: '',
        content: [],
        recommended_product: [],
      };
      this.initQuicktipsDetail(detail);
      this.$router.push({ name: 'QuicktipsDetailPage', params: { id: this.bu.id } });
    },
    editItem(detail) {
      this.initQuicktipsDetail(detail);
      this.$router.push({ name: 'QuicktipsDetailPage', params: { id: this.bu.id } });
    },
    deleteItem(index) {
      this.bu.quiktips.details.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.bu.quiktips.details.length - 1) {
        this.bu.quiktips.details.splice(i, 1);
        this.bu.quiktips.details.unshift(item);
        return;
      }
      // item become next index
      this.bu.quiktips.details.splice(i, 1);
      this.bu.quiktips.details.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.bu.quiktips.details.splice(i, 1);
        this.bu.quiktips.details.push(item);
        return;
      }
      // item become previous index
      this.bu.quiktips.details.splice(i, 1);
      this.bu.quiktips.details.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
